<div class="footer w-100 h-100">
  <div class="upper mb-1 p-4" *ngIf="show">
    <div class="row justify-content-center text-center text-lg-start">
      <!-- <div class="col-lg-4 col-md-12 mb-4 mb-md-0">
        <h5 class="text-uppercase">{{ "footer.directAccess" | msg | async }}</h5>
        <app-nav-item-list
          [items]="footerLinks"
          [toUpperCase]="true"
        ></app-nav-item-list>
      </div> -->
      <div class="col-lg-4 col-md-12 mb-4 mb-md-0">
        <h5 class="text-uppercase">
          {{ "footer.assekuranzAppenzellAusserrhoden" | msg | async }}
        </h5>
        <app-nav-item-list [items]="contactItems"></app-nav-item-list>
      </div>
      <div class="col-lg-4 col-md-12 mb-4 mb-md-0">
        <h5>{{ "footer.openingHours" | msg | async }}</h5>
        <app-nav-item-list [items]="infoItems"></app-nav-item-list>
      </div>
    </div>
  </div>

  <div class="lower p-3 w-100 h-100">
    <div class="row text-center text-lg-start">
      <div class="col-lg-4 col-md-12 mb-4 mb-md-0">© Assekuranz AAR 2024</div>
      <!-- <div class="col-lg-4 col-md-12 mb-4 mb-md-0"></div>
      <div class="col-lg-4 col-md-12 mb-4 mb-md-0"></div> -->
    </div>
  </div>
</div>
